import { DEFAULT_TIME_CONTROL_ID } from '@chess/core'
import { useMemo, type JSX } from 'react'
import { timeControlParam } from '../lib/router.js'
import { resolveTimeControl } from '../lib/timeControls.js'
import { useLocalRoom } from '../room/connection.js'
import { RoomView } from '../room/RoomView.js'

export interface LocalGameProps {
  readonly navigate: (to: string) => void
}

/**
 * Hotseat. The board flips to whoever is to move, because `useLocalRoom`
 * reports the side to move as the acting player — the room reducer is the same
 * one the server runs.
 */
export const LocalGame = ({ navigate }: LocalGameProps): JSX.Element => {
  const control = useMemo(() => resolveTimeControl(timeControlParam(DEFAULT_TIME_CONTROL_ID)), [])

  const connection = useLocalRoom(control)

  return (
    <RoomView
      connection={connection}
      mySlot={connection.actor.kind === 'player' ? connection.actor.slot : null}
      header={
        <header className="flex items-center justify-between px-2 py-2 safe-top sm:px-0">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="text-sm font-semibold text-ink-dim hover:text-ink"
          >
            ← Home
          </button>
          <span className="text-xs font-semibold tracking-wide text-ink-dim uppercase">
            Both sides, one device
          </span>
        </header>
      }
    />
  )
}
